import { useParams } from "react-router-dom";
import { motion } from "framer-motion";
import IRMenu from "./IRMenu"
import commoncss from "../../../myfin_v2/css/common.module.css"
import investmentRegisterCss from "../../../myfin_v2/css/investmentRegister.module.css";


const Repository = () => {

    const { irId } = useParams();

    return (
        <>
            <div className={`d-flex ${commoncss.pageContent}`}>
                <IRMenu 
                    activeTab={"Repository"}
                    registerID={irId}
                />
                <motion.div
                    initial={{ x: 200, opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    exit={{ x: 200, opacity: 0 }}
                    transition={{ duration: 1, ease: "easeInOut" }}
                    className={investmentRegisterCss.irLayout}
                >

                    <div className={investmentRegisterCss.comingSoon}>
                        <span>
                            Coming Soon...
                        </span>
                    </div>

                </motion.div>
            </div>
        </>
    )
}

export default Repository;